import {request} from './request';
import * as PATHS from '@/constants/path';
import {URLParamBuilder} from '@/utils/functions';

export function fetchExtraFieldTypesList({ query }: { query?: Record<string, any> }) {
  const url = URLParamBuilder(PATHS.FETCH_EXTRA_FIELD_TYPES, { queryString: query });
  return request(url, { method: 'GET' });
}

export function createExtraFieldTypeRequest({ data }: { data: any }) {
  return request(PATHS.CREATE_EXTRA_FIELD_TYPE, { method: 'POST', data });
}

export function editExtraFieldTypeRequest({
  data,
  params,
}: {
  data: any;
  params: { extraFieldTypeId: string };
}) {
  const url = URLParamBuilder(PATHS.EDIT_EXTRA_FIELD_TYPE, { params });
  return request(url, { method: 'PUT', data });
}

export function deleteExtraFieldTypeRequest({ params }: { params: { extraFieldTypeId: string } }) {
  const url = URLParamBuilder(PATHS.DELETE_EXTRA_FIELD_TYPE, { params });
  return request(url, { method: 'DELETE' });
}

export function reorderExtraFieldTypeRequest({
  data,
  params,
}: {
  data: { extra_field_types: string[] };
  params: { relatedTo: string };
}) {
  const url = URLParamBuilder(PATHS.REORDER_EXTRA_FIELD_TYPE, { params });
  return request(url, { method: 'POST', data });
}

export function createExtraFieldTypeOptionRequest({
  data,
  params,
}: {
  data: any;
  params: { extraFieldTypeId: string };
}) {
  const url = URLParamBuilder(PATHS.CREATE_EXTRA_FIELD_TYPE_OPTION, { params });
  return request(url, { method: 'POST', data });
}

export function editExtraFieldTypeOptionRequest({
  data,
  params,
}: {
  data: any;
  params: { extraFieldTypeOptionId: string };
}) {
  const url = URLParamBuilder(PATHS.EDIT_EXTRA_FIELD_TYPE_OPTION, { params });
  return request(url, { method: 'PUT', data });
}

export function deleteExtraFieldTypeOptionRequest({
  params,
}: {
  params: { extraFieldTypeOptionId: string };
}) {
  const url = URLParamBuilder(PATHS.DELETE_EXTRA_FIELD_TYPE_OPTION, { params });
  return request(url, { method: 'DELETE' });
}

export function setExtraFieldValueRequest({
  params,
  data,
}: {
  params: { extraFieldTypeId: string; leadId: string };
  data: { value: any };
}) {
  const url = URLParamBuilder(PATHS.SET_EXTRA_FIELD_VALUE, { params });
  return request(url, { method: 'POST', data });
}

export function removeExtraFieldValueRequest({
  params,
}: {
  params: { extraFieldTypeId: string; leadId: string };
}) {
  const url = URLParamBuilder(PATHS.CLEAR_EXTRA_FIELD_VALUE, { params });
  return request(url, { method: 'DELETE' });
}

export function getExtraFieldTypeValueCount({ params }: { params: { extraFieldTypeId: string } }) {
  const url = URLParamBuilder(PATHS.GET_EXTRA_FIELD_TYPE_VALUE_COUNT, { params });
  return request<API.Response<{ total_count: number; breakdown: Record<string, number> }>>(url, {
    method: 'GET',
  });
}
